import { getCurrentRegion, Region } from "@/utils/environment";

interface ApiConfig {
  name: string;
  core: string;
  analytics: string;
  inventory: string;
  pusher: {
    key: string;
    cluster: string;
    appId: string;
  };
}

/**
 * Get API configuration based on the current environment
 * All URLs are now driven by environment variables defined in .env file
 */
export const getApiConfig = (): ApiConfig => {
  const region = getCurrentRegion();

  //

  // Default fallback URLs for each environment
  const defaults = {
    development: {
      name: "Development",
      core: "https://craveretail-dev.uc.r.appspot.com",
      analytics: "https://reporting-api-dot-craveretail-dev.uc.r.appspot.com",
      inventory:
        import.meta.env.VITE_INVENTORY_API_URL ??
        "https://inventory-dot-craveretail-dev.uc.r.appspot.com",
      pusher: {
        appId: "780628",
        key: "5d3657875c763e1b0282",
        cluster: "us3",
      },
    },
    production: {
      name: "Production",
      core: "https://craveretail-prod.appspot.com",
      analytics: "https://reporting-api-dot-craveretail-prod.uc.r.appspot.com",
      inventory: import.meta.env.VITE_INVENTORY_API_URL ?? "https://inventory.na.crave-cloud.com",
      pusher: {
        appId: "780630",
        key: "0c5a925d0288d5249d84",
        cluster: "us3",
      },
    },
    eu: {
      name: "Europe",
      core: "https://craveretail-eu.ew.r.appspot.com",
      analytics: "https://reporting-api-dot-craveretail-eu.ew.r.appspot.com",
      inventory: import.meta.env.VITE_INVENTORY_API_URL ?? "https://inventory.eu.crave-cloud.com",
      pusher: {
        appId: "1013229",
        key: "66ad40c33171a8333d91",
        cluster: "eu",
      },
    },
  };

  // Use environment-specific variables
  let config: ApiConfig;

  switch (region) {
    case Region.NA:
      config = defaults.production;
      break;
    case Region.EMEA:
      config = defaults.eu;
      break;
    case Region.DEV:
      config = defaults.development;
      break;
  }

  // ,
  //   core: config.core,
  //   analytics: config.analytics,
  //   inventory: config.inventory
  // });

  return config;
};
